var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.98719L35.06 30.0072H4.94L20 3.98719ZM1.48 28.0072C-0.0600016 30.6672 1.86 34.0072 4.94 34.0072H35.06C38.14 34.0072 40.06 30.6672 38.52 28.0072L23.46 1.98719C21.92 -0.672812 18.08 -0.672812 16.54 1.98719L1.48 28.0072ZM18 14.0072V18.0072C18 19.1072 18.9 20.0072 20 20.0072C21.1 20.0072 22 19.1072 22 18.0072V14.0072C22 12.9072 21.1 12.0072 20 12.0072C18.9 12.0072 18 12.9072 18 14.0072ZM18 24.0072H22V28.0072H18V24.0072Z",
    fill: "#ab9628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0902b44ac6646e9898b77571cfa3a01d.svg";
export { ForwardRef as ReactComponent };